import { render, staticRenderFns } from "./chooseService.vue?vue&type=template&id=67daa848&scoped=true"
import script from "./chooseService.vue?vue&type=script&lang=js"
export * from "./chooseService.vue?vue&type=script&lang=js"
import style0 from "./chooseService.vue?vue&type=style&index=0&id=67daa848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67daa848",
  null
  
)

export default component.exports